<template>
    <v-container style="height:100%" fluid class="">
        <v-row align="center" justify="center">
            <v-col cols="12" sm="12" md="12">
                <!-- <v-card class="elevation-4 "> -->
                    <!-- <v-card-title>
                        <h4 class="title">{{$t('zz_edit_course')}}</h4>
                    </v-card-title> -->
                    <v-card-text>
                        <v-divider></v-divider>
                        <v-form v-model="valid" enctype="multipart/form-data" id="editcourse">
                            <v-container pa-3 class="cards-container">
<!-- MASTER DETAILS -->
                                    <template>
<!--Page Header  -->
                                        <v-col cols="12" md="12" class="" style="justify-content:space-around">
                                            <div class="section-label pb-0 ma-0">{{$t('zz_course_information')}}</div>
                                            <div class="english-label-black pt-0 ma-0 mb-10">COURSE HEADNIG BANNER</div>
                                        </v-col>



                                        <v-card elevation="0" class="ma-0 pa-0">
                                            <v-row no-gutters style="justify-content: space-between;align-items: center;">
                                                        <div class="pa-3 card-title card-preview ">{{$t('zz_preview')}}</div>
                                                        <!-- <v-switch style="justify-content:flex-end;" class="pt-3 pr-3" label="" v-model="data.status" color="success"></v-switch> -->
                                                        <v-row>
                                                <v-col cols="12" md="12" class="text-right">
                                                    <div class="ma-0 pa-0">
                                                        <v-dialog
                                                        v-model="dialog"
                                                        width="800"
                                                        v-bind="attrs"
                                                        v-on="on">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-btn
                                                                x-small
                                                                elevation="2"
                                                                color="#FE5800"
                                                                fab
                                                                v-bind="attrs"
                                                                v-on="on">
                                                                    <v-icon color="white">mdi-information-variant</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <v-card>
                                                            <v-card-title class="section-spread text-h1 zzorganebg">
                                                                <h1 class="font-weight-bold display-1 text--pr"><v-icon style="font-size:50px;color:white" class="pr-2">mdi-book-arrow-down</v-icon>{{$t('zz_course_information')}}</h1>
                                                            </v-card-title>
                                                            <p class="pt-5 px-4">
                                                                <span v-html="$t('zz_course_name')"></span><br>
                                                                <span v-html="$t('zz_course_name_explainer')"></span>
                                                            </p><br>
                                                            <v-divider></v-divider>
                                                            <!-- <p class="pt-5 px-4">
                                                                <span v-html="$t('zz_course_price')"></span><br>
                                                                <span v-html="$t('zz_course_price_explainer')"></span>
                                                            </p><br>
                                                            <v-divider></v-divider>
                                                            <p class="pt-5 px-4">
                                                                <span v-html="$t('zz_course_price_text')"></span><br>
                                                                <span v-html="$t('zz_course_price_text_explainer')"></span>
                                                            </p><br>
                                                            <v-divider></v-divider>
                                                            <p class="pt-5 px-4">
                                                                <span v-html="$t('zz_course_description')"></span><br>
                                                                <span v-html="$t('zz_course_description_explainer')"></span>
                                                            </p><br>
                                                            <v-divider></v-divider>
                                                            <p class="pt-5 px-4"><span v-html="$t('zz_remember_to_save')"></span></p><br> -->
                                                            <v-divider></v-divider>
                                                            <p class="pt-5 px-4"><span v-html="$t('zz_remember_update_transaltions')"></span></p><br>
                                                            </v-card>
                                                        </v-dialog>
                                                    </div>
                                                </v-col>
                                            </v-row>
                                            </v-row>
                                            <!-- <v-row class="pa-3">
                                                <v-img class="full-width screen" :src="phonescreen"></v-img>
                                            </v-row> -->

<!--PREVIEW  -->
                                        <!-- <img class="arrow-left1" :src="arrowleft"></img> -->
                                        <!-- <img class="arrow-left2" :src="arrowleft"></img> -->
                                        <!-- <img class="arrow-left3" :src="arrowleft"></img> -->
                                        <v-card elevation="0" style="position:sticky;top:0px" class="mt-12 max-400 d-md-block pa-0 ma-0" height="68vh">

                                            <!-- <v-container v-if="data.status" class="relative pwacontent pa-0 ma-0"> -->

                                            <div v-if="data.status==0" flex-wrap class="coursehidden"><span v-html="$t('zz_hidden_item_notice_course')"></span></div>
                                            <v-container class="relative pwacontent pa-0 ma-0">

                                                <v-img class="full-width screen" :src="phonescreen5"></v-img>
                                                <v-container style="position:relative;top:50px" :class="[data.status?'relative pwacontent pa-0 ma-0':'inactive max-350 pa-3 mt-10']" class="max-350 pa-3 mt-10">
                                                    <v-container class="true-center pa-0 ma-0">
                                                    <v-row style="align-items:center;flex-flow:nowrap">
                                                        <span class="imgaesfade top-placeholders">Starters </span><span class="heading-abs1 ">{{data.name}}</span><span class="imgaesfade top-placeholders"> Desserts</span>
                                                        </v-row>
                                                    <v-row class="heading-abs2 text-left pa-0 px-3 ma-0">{{data.name}}</v-row>
                                                    <!-- <v-img :src="pwatop3" class="imgaesfade full-width pa-0 ma-0"/> -->
                                                    </v-container>
                                                    <v-row no-gutters class="pa-0 ma-0">
                                                        <v-col cols="12" class="pwa-bg pa-0 ma-0 py-1" style="background-color:primary">
                                                            <br><br>
                                                            <p :class="[data.showon?'price pt-4 pb-0 text-center':'inactive price pt-4 pb-0 text-center']">{{data.price}}</p>
                                                            <p :class="[data.showon?'price-text ma-0 pb-1 text-center':'inactive price-text ma-0 pb-1 text-center']"   >{{data.pricetext}}</p>
                                                            <p :class="[data.showon?'descr px-10 py-3':'inactive descr px-10 py-3']" v-html="data.description"></p>
                                                            <!-- <p class="pwa-bg pa-3 my-n1 text-center">{{data.description}}</p> -->
                                                        </v-col>
                                                    </v-row>
                                                    <v-img style="" class="imgaesfade" :src="pwabottom"/>
                                                </v-container>
                                            </v-container>
                                        </v-card>
                                        </v-card>


<!-- EDIT DETAILS CARD STARTS HERE                                         -->
                                        <v-card elevation="0" class="ma-0 pa-0">
                                            <v-row no-gutters style="justify-content: space-between;align-items: center;">
                                                <div class="pa-3 card-title card-preview">{{$t('zz_show_on_juZZap')}}</div>
                                                <v-switch style="justify-content:flex-end;" class="pt-3 pr-3" label="" v-model="data.status" color="success"></v-switch>
                                            </v-row>
                                            <v-row no-gutters style="justify-content: space-between;align-items:flex-end" class="pa-3">
                                                <div v-if="data.status==0" flex-wrap class="hidden-notice2"><span v-html="$t('zz_hidden_item_notice_course')"></span></div>
                                                <div v-if="data.status==0" class="">
                                                    <v-dialog
                                                    v-model="dialog"
                                                    width="800"
                                                    v-bind="attrs"
                                                    v-on="on">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn
                                                                x-small
                                                                elevation="2"
                                                                color="#FE5800"
                                                                fab
                                                                v-bind="attrs"
                                                                v-on="on">
                                                                <v-icon color="white">mdi-eye-off-outline</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <v-card>
                                                        <v-card-title class="section-spread text-h1 zzorganebg">
                                                            <h1 class="font-weight-bold display-1 text--pr"><v-icon style="font-size:50px;color:white" class="pr-2">mdi-eye-off-outline</v-icon>{{$t('zz_hidden_item_notice')}}</h1>
                                                        </v-card-title>
                                                        <p class="pt-5 px-4">
                                                            <span v-html="$t('zz_hidden_course_explained')">
                                                            </span>
                                                        </p><br>
                                                        <v-divider></v-divider>
                                                        <p class="pt-5 px-4"><span v-html="$t('zz_remember_to_save')"></span></p><br>
                                                        </v-card>
                                                    </v-dialog>
                                                </div>
                                            </v-row>
                                            <v-card elevation=12 style="flex-flow: column wrap" class="relative max-400 card-in-cards-container-strech px-3 ma-0">

                                            <v-row style="justify-content:center" class="pa-3">

<!-- TITLE MASTER -->
                                                <v-col cols="12" md="12" class="">
                                                    <v-text-field
                                                        class="course-title"
                                                        v-model="data.name"
                                                        name="name"
                                                        :label="$t('zz_course_name')">
                                                    </v-text-field>
                                                </v-col>
                                            </v-row>
                <v-row class="">
                    <!-- <v-divider class="mb-3 mt-10 mx-0 px-0"></v-divider> -->
                <!-- </v-row> -->
                                            <v-row class="pa-3 ma-3 py-5">
                                                <v-container class="ma-0 pa-0">
                                                    <v-row no-gutters>
                                                    <v-col cols="12" class="pa-0 ma-0">
                                                    <v-row class="pr-3 pl-6" style="justify-content:space-between;align-items:baseline">
                                                        <div class="card-preview">{{$t('zz_show_course_banner')}}</div>
                                                        <v-switch style="justify-content:flex-end;" class="" label="" v-model="data.showon" color="success"></v-switch>
                                                    </v-row>
                                                    <v-row no-gutters style="justify-content: space-between;align-items:flex-end" class="pa-3">
                                                        <div v-if="data.showon==0" flex-wrap class="hidden-notice2"><span v-html="$t('zz_hidden_item_notice_course_heading')"></span></div>
                                                        <div v-if="data.showon==0" class="">
                                                            <v-dialog
                                                            v-model="dialog"
                                                            width="800"
                                                            v-bind="attrs"
                                                            v-on="on">
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-btn
                                                                        x-small
                                                                        elevation="2"
                                                                        color="#FE5800"
                                                                        fab
                                                                        v-bind="attrs"
                                                                        v-on="on">
                                                                        <v-icon color="white">mdi-eye-off-outline</v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <v-card>
                                                                <v-card-title class="section-spread text-h1 zzorganebg">
                                                                    <h1 class="font-weight-bold display-1 text--pr"><v-icon style="font-size:50px;color:white" class="pr-2">mdi-eye-off-outline</v-icon>{{$t('zz_hidden_item_notice')}}</h1>
                                                                </v-card-title>
                                                                <p class="pt-5 px-4">
                                                                    <span v-html="$t('zz_hidden_course_explained')">
                                                                    </span>
                                                                </p><br>
                                                                <v-divider></v-divider>
                                                                <p class="pt-5 px-4"><span v-html="$t('zz_remember_to_save')"></span></p><br>
                                                                </v-card>
                                                            </v-dialog>
                                                        </div>
                                                    </v-row>
                                                    </v-col>
                                                </v-row>
                                                </v-container>
                                                <v-col cols="12" md="12">
<!-- PRICE MASTER -->
                                                    <v-text-field
                                                    :class="[data.showon?'price':'price inactive']"
                                                    color="primary"
                                                    v-model="data.price"
                                                    name="price"
                                                    :label="$t('zz_price')"
                                                    ></v-text-field>
                                                </v-col>
<!-- Price Text Master -->
                                                <v-col cols="12" md="12">
                                                    <v-text-field
                                                    :class="[data.showon?'price_explainer':'inactive']"
                                                    v-model="data.pricetext"
                                                    name="pricetext"
                                                    :label="$t('zz_price_text')"
                                                    ></v-text-field>
                                                </v-col>
<!-- DESCRIPTION MASTER -->
                                                <v-col cols="12" sm="12" md="12" >
                                                    <v-row>
                                                <v-col cols="9" sm="9" md="9" :class="[data.showon?'':'inactive']">{{$t('zz_description')}}</v-col>
                                                </v-row>
                                                    <editor
                                                    api-key="kmqk9zj3cswmwgz5j95fcwx8fh4nutj31o7ru7va5lxht7nk"
                                                    initialValue=""
                                                    v-model="data.description"
                                                    :init="editorConfigDescription"
                                                    :class="[data.showon?'':'inactive']"

                                                    ></editor>
                                                </v-col>

                                            </v-row>
                                            </v-row>
                                            <v-row class="my-6 pa-6">
                                                <span v-html="$t('zz_remember_update_transaltions')"></span>
                                            </v-row>
                                        </v-card>
                                        </v-card>
                                    </template>

<!--  TRANSLATIONS CARDS    -->
                                    <v-col cols="12" md="12" class="pl-3 mt-12">
                                        <div class="section-label pb-0 ma-0">{{$t('zz_translations')}}</div>
                                        <div class="english-label pt-0 ma-0">TRANSLATIONS</div>
                                    </v-col>
                                    <v-card elevation="12" class="max-400 card-in-cards-container-strech pt-5 pa-6" v-for="(tlang,ind) in translationlanguages" :key="'coursetitle-'+tlang">
                                        <v-row style="flex-flow:column wrap" class="">
<!-- PRICE TEXT TRANSLATION -->
                                            <v-col cols="12" md="12" style="justify-content:center" class="text-center mb-50 pb-3">
                                                <img :src="'https://api.juzzap.com/storage/flags/'+tlang+'.svg'" height="20px">
                                                <span class="lang-short-code"> - {{tlang}}</span>
                                                <v-text-field
                                                    class="course-title pt-3 mt-5"
                                                    v-model="languagetranslations[tlang].title"
                                                    name="tpricetext[tlang]"
                                                    :label="$t('zz_course_name')"
                                                    >
                                                </v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="12">
                                                <v-text-field
                                                    class="price_explainer pt-3 mt-5"
                                                    v-model="languagetranslations[tlang].subtitle"
                                                    name="tpricetext[tlang]"
                                                    :label="$t('zz_price_text')">
                                                </v-text-field>
                                                </v-col>
<!-- DESCRIPTION TRANSLATION -->
                                                    <v-row class="pa-3 ">
                                                        <v-col cols="9" sm="9" md="9">
                                                            {{$t('zz_description')}}
                                                        </v-col>
                                                        <v-col cols="3" md="3" class="pb-0">
                                                            <v-switch label="" style="justify-content:flex-end" v-model="data.showon" color="success"></v-switch>
                                                        </v-col>
                                                    </v-row>
                                                    <v-col cols="12" sm="12" md="12" >
                                                        <editor
                                                                api-key="kmqk9zj3cswmwgz5j95fcwx8fh4nutj31o7ru7va5lxht7nk"
                                                                initialValue=""
                                                                v-model="languagetranslations[tlang].description"
                                                                :init="editorConfigDescription">
                                                        </editor>
                                                    </v-col>
                                        </v-row>
                                    </v-card>
                            </v-container>
                            <v-divider></v-divider>
                            <v-footer padless fixed class="footer-1">
                                <v-row class="py-2 pl-5">
                                    <!-- <v-col cols="12"> -->
                                        <v-btn class="d-none d-md-flex px-3 px-2 ma-1 footer-buttons"  color="#FE5800" elevation="21" large  @click="submit" >{{$t('zz_save')}}</v-btn>
                                        <v-btn class="d-md-none d-lg-none d-xl-none px-3 ma-1 footer-buttons" color="#FE5800" elevation="21" small  @click="submit" >{{$t('zz_save')}}</v-btn>


                                        <v-btn class="d-none d-md-flex px-3 px-2 ma-1" outlined color="#FE5800" elevation="21" large  @click.prevent="$emit('set-dialog')">{{$t('zz_exit')}}</v-btn>
                                        <v-btn class="d-md-none d-lg-none d-xl-none px-3 ma-1" outlined color="#FE5800" elevation="21" small  @click.prevent="$emit('set-dialog')">{{$t('zz_exit')}}</v-btn>


                                        <!-- <v-btn class="d-none d-md-flex px-3 px-2 ma-1" outlined color="#FE5800" elevation="21" large  @click="$router.push({name:'businessfoodlist'});">{{$t('zz_exit')}}</v-btn>
                                        <v-btn class="d-md-none d-lg-none d-xl-none px-3 ma-1" outlined color="#FE5800" elevation="21" small  @click="$router.push({name:'businessfoodlist'});">{{$t('zz_exit')}}</v-btn> -->
                                    <!-- </v-col> -->
                                </v-row>
                            </v-footer>
                    </v-form>
                </v-card-text>

            </v-col>
        </v-row>

    </v-container>

</template>
<script>
import Vue from 'vue'
import VeeValidate from "vee-validate";
import { Cropper } from 'vue-advanced-cropper'
import Editor from '@tinymce/tinymce-vue'


Vue.use(VeeValidate);
export default{

    props: ['cid'],
    data: () => ({
        editorData: '',
        editorConfigDescription: {height: 200,
            menubar: false,
            //  plugins: [
            //    'advlist autolink lists link image charmap print preview anchor',
            //    'searchreplace visualblocks code fullscreen',
            //    'insertdatetime media table paste code wordcount autoresize'
            //  ],
            toolbar:
            ' bold italic | alignleft aligncenter alignright alignjustify'
        },

        pwatop1:require('@/assets/pwa_food_top1.png'),
        pwatop2:require('@/assets/pwa_food_top2.png'),
        pwatop3:require('@/assets/pwa_food_top3.png'),
        pwabottom:require('@/assets/pwa_food_bottom.png'),
        phonescreen:require('@/assets/phone-vector.svg'),
        phonescreen2:require('@/assets/phone-vector2.svg'),
        phonescreen3:require('@/assets/phone-vector3.svg'),
        phonescreen4:require('@/assets/phone-vector4.svg'),
        phonescreen5:require('@/assets/phone-vector5.svg'),
        phonescreen6:require('@/assets/phone-vector6.svg'),
        arrow1:require('@/assets/arrows/arrow1.svg'),
        arrowright:require('@/assets/arrows/arrow-right.svg'),
        arrowleft:require('@/assets/arrows/arrow-left.svg'),





        statuslist: [{name:"Active",value:1}, {name:"Inactive",value:0}],
        status:"",
        showon: "",
        showonlist: [{name:"True",value:1}, {name:"False",value:0}],

        valid: true,
        name:"",
        dictionary:
        {
                    attributes: {
                        name: "Course Name",
                    },
                    custom: {}
        },
        data:[],
        business:[],
        business_id:0,

        businessID:0,
        id: "",
        mainimg:null,
        image:null,
        coordinates: {
          width: 0,
          height: 0,
          left: 0,
          top: 0
        },
        translationlanguages:[],
        languagetranslations:[],

    }),
    created() {
        // if (this.$route.params.id) {
        // this.id = this.$route.params.id;
        // }
        // this.fetchdata();

    },
    watch:
    {
      cid:function(value)
        {
            this.id=this.cid;

            return value;
        }
    },
    mounted()
    {
        this.$validator.localize("en", this.dictionary);

        this.id=this.cid;
        if(this.id)
        {
            this.fetchdata();
        }
    },
    components: {
        'editor': Editor,

      Cropper
    },
    methods: {
        onChangeImage({coordinates, canvas})
        {
            this.coordinates = coordinates

            this.image = canvas.toDataURL()
        },
        mainim(event)
        {
            var input = event.target;
            // Ensure that you have a file before attempting to read it
            if (input.files && input.files[0])
            {
                // create a new FileReader to read this image and convert to base64 format
                var reader = new FileReader();
                // Define a callback function to run, when FileReader finishes its job
                reader.onload = (e) => {
                    // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                    // Read image as base64 and set to imageData
                    this.mainimg = e.target.result;
                }
                // Start the reader job - read file as a data url (base64 format)
                reader.readAsDataURL(input.files[0]);
            }
        },
        dataURLtoFile(dataurl, filename)
        {

            var arr = dataurl.split(','),
                  mime = arr[0].match(/:(.*?);/)[1],
                  bstr = atob(arr[1]),
                  n = bstr.length,
                  u8arr = new Uint8Array(n);

            while(n--){
                  u8arr[n] = bstr.charCodeAt(n);
            }

            return new File([u8arr], filename, {type:mime});
        },
         fetchdata() {

              if(localStorage.getItem('business'))
                {
                    this.business=JSON.parse(localStorage.getItem('business'));
                    //fd.append('business_id',this.business['id']);
                    this.business_id=this.business['id'];

                }
                else
                {
                    //fd.append('business_id',0);
                    this.business_id=0;

                }

             this.$http
            .get(this.$apidomain+"courseDatapwa/" + this.id+"/"+this.business_id)
            .then(res => {
            this.data=res.data.course;
            this.image=this.data.image;
            this.translationlanguages=res.data.course.translationlanguages;
            this.languagetranslations=res.data.course.languagetranslations;
            // console.log(res.data.businesses);
            })
            .catch(err => {
            console.log(err.response);
            });
         },
        submit() {
            let th = this;
            if (this.$validator.validateAll()) {
                let fd = new FormData(document.getElementById("editcourse"));

                if(this.mainimg!=null)
                {
                    fd.append('image',this.dataURLtoFile(this.image,document.getElementById('image').files[0].name));
                }


                fd.append('customcourse',this.data.customcourse);
                fd.append('languagetranslations',JSON.stringify(this.languagetranslations));

                //fd.append('status',this.data.status);

                //fd.append('showon',this.data.showon);

                if(this.data.showon)
                {
                fd.append('showon',1);
                }
                else
                {
                fd.append('showon',0);

                }

                if(this.data.status)
                {
                fd.append('status',1);
                }
                else
                {
                fd.append('status',0);

                }

                fd.append('description',this.data.description);


                if(localStorage.getItem('business'))
                {
                    this.business=JSON.parse(localStorage.getItem('business'));
                    //fd.append('business_id',this.business['id']);
                    this.business_id=this.business['id'];

                }
                else
                {
                    //fd.append('business_id',0);
                    this.business_id=0;

                }

                this.$http
                .post(this.$apidomain+"updateCoursepwa/"+this.id+'/'+this.business_id, fd)
                .then(res => {
                    if(res.data.success)
                    {

                        // this.$router.push({name:'courselist'});

                        //this.$router.push("/courselist");

                        this.$router.go("/");
                    }
                    else
                    {
                        let errmsg=[];
                        for(var prop in res.data.errors){
                            errmsg.push(res.data.errors[prop][0]);
                        }
                        alert(errmsg[0]);
                    }
                })
                .catch(err => {
                    console.log(err.response);
                });
            }
        }
}

}
</script>
<style>


.cards-container{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    /* justify-content: space-around; */
    justify-content: space-evenly;
    align-items: stretch;
    /* align-items: flex-start; */

}
.card-in-cards-container{
    /*flex: 1 1 ;   Stretching: */
     flex: 0 1 300px; /* No stretching: */
    margin: 50px;
    /* background-color: #FE5800; */
}
.card-in-cards-container-strech{
    flex: 1 1 350px;   /*  Stretching:
     flex: 0 1 300px;No stretching: */
    margin: 5px;
    /* background-color: #FE5800; */
}
.max-350{
    max-width: 350px;
}

.course-title{
    font-size: 30px;
    font-weight: bold;

}
.price{
    font-size: 20px;
    font-weight: 600;

}
.price_explainer{
    font-size: 14px;
    font-weight: 400;

}
.pwa-bg{
    background-color: #f3f3f3;
}
.relative{
    position: relative;
}
.heading-abs1{
    position: relative;
    top: -7px;
    color: #fff;
    font-weight: bold;
    background-color: #fe5800;
    padding: 10px;
    inline-size: fit-content;
    z-index: 1;
    line-height: .75;

}
.top-placeholders{
    position: relative;
    top: -7px;
    color: rgb(57, 57, 57);
    font-weight: 400;
    /* background-color: #fe5800; */
    padding: 10px;
    inline-size: fit-content;
    z-index: 1;
    line-height: .75;

}
.heading-abs2{
    position: absolute;
    top: 53px;
    left: 25px;
    color: rgb(91, 91, 91);
    font-weight: bold;
    padding: 10px;
    inline-size: fit-content;
    z-index: 3;
}
.true-center{
    display: grid;
    place-items: center;
}
.price{
    font-size: 16px;
    font-weight: 600;
}
.price-text{
    font-size: 14px;
    font-weight: 500;
}
.descr{
    font-size: 12px;
    font-weight: 400;
    text-align: justify;
    color: rgb(102, 102, 102);
    line-height: 1;
    }
.full-width{
    width: 100%;
}
.imgaesfade{
    opacity: .5;
    filter: blur(1.5px);
}
.inactive{

    opacity: 0.25;
    /* text-decoration:line-through; */
}
.hidden-notice2{
  color: #FE5800;
  flex-wrap: wrap;
  font-size: 25px;
  font-weight: 800;

}
.sectitle{
    font-size: 20px;
    font-weight: 800;
}
.screen{
    /* width: 400px; */
    position: absolute;
    top: 0px;
    z-index: 3;
    /* opacity: .5; */
    overflow: hidden;
    /* filter: blur(2.5px); */

}
.screentop{
    margin-top: 50px;
}
.pwacontent{
    position: relative;
    top: 36px;
}
.coursehidden{
    position: absolute;
    top: 45%;
    left: 50px;
    right: 50px;
    flex: 1 1 150px;
    text-align: center;
    font-size: 50px;
    line-height: 1;
    font-weight: bold;
    color: #FE5800;
    opacity: 1 !important;
    z-index: 10

}
.arrow1{
    position: absolute;
    z-index: 14;
    left: 10px;
    top: 10px;
    flex: 1 1 125px; /*  Stretching: */

}
.arrow-left1{
    position: absolute;
    z-index: 14;
    right: -95px;
    top: 195px;
    width: 100px;
}
.arrow-left2{
    position: absolute;
    z-index: 14;
    right: -95px;
    top: 233px;
    width: 100px;
}
.arrow-left3{
    position: absolute;
    z-index: 14;
    right: -95px;
    top: 300px;
    width: 100px;
}
</style>
